'use client';

import { styled } from '../../styles';
import { List } from '../List';

export const SelectMobileItem = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

export const SelectMobileItemLabel = styled.span(() => ({ flex: 1 }));

export const SelectMobileList = styled(List)<{
  disableScroll?: boolean;
  withPadding?: boolean;
}>(({ disableScroll, theme, withPadding }) => ({
  overflow: disableScroll ? 'hidden' : 'auto',
  padding: theme.spacing(0, 2),
  paddingTop: withPadding ? theme.spacing(2) : undefined,
}));
